((document, window, history) => {
	const pushState = history.pushState;
	const windoWidth = window.innerWidth;

	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	// lazyloading
	function lazyloadElements() {
		const observer = new IntersectionObserver(function(entries, obs) {
			entries.forEach(function(entry) {
				// If the entry is not in the viewport, do nothing
				if (!entry.isIntersecting) {
					return;
				}

				// Stop observing
				obs.unobserve(entry.target);

				// Add class
				entry.target.classList.add('in-view');
			});
		});

		// The element to observe
		const elements = (document.querySelector('.site-page').children);

		for (let i = 0; i < elements.length; i += 1) {
			// Attach it to the observer
			observer.observe(elements[ i ]);
		}
	}

	function countUp(_sel) {
		function animateValue(start, end, durationMs, element, suffix = '') {
			const range = end - start;
			let current = start;
			const increment = end > start ? 1 : -1;
			const stepTime = Math.abs(Math.floor(durationMs / range));
			const timer = setInterval(() => {
				current += increment;
				if (suffix === '%' && Number.isInteger(current)) {
					element.textContent = current + suffix;
				} else {
					element.textContent = current.toFixed(2);
				}
				if (current === end) {
					clearInterval(timer);
				}
			}, stepTime);
		}

		const options = {
			rootMargin: '0px',
			threshold: 0.5
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const value = parseFloat(entry.target.textContent);
					const suffix = entry.target.textContent.replace(value, '').trim();
					animateValue(0, value, 2000, entry.target, suffix);
					observer.unobserve(entry.target);
				}
			});
		}, options);

		observer.observe(_sel);
	}

	function slider(_sel) {
		const config = {
			autoPlay: true,
			cellAlign: 'center',
			draggable: true,
			freeScroll: true,
			prevNextButtons: false,
			pageDots: false,
			wrapAround: true,
			adaptiveHeight: false,
			lazyLoad: false
		};

		if (_sel.classList.contains('site-case-studies-listing__card-list')) {
			config.prevNextButtons = true;
			config.freeScroll = false;
		}

		return new Flickity(_sel, config);
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-statistics__item-heading')) {
			document.querySelectorAll('.site-statistics__item-heading').forEach((_sel) => {
				countUp(_sel);
			});
		}

		if (document.querySelector('.site-job-listing__slider')) {
			document.querySelectorAll('.site-job-listing__card-list').forEach((_sel) => {
				slider(_sel);
			});
		}

		if (document.querySelector('.site-case-studies-listing__slider')) {
			document.querySelectorAll('.site-case-studies-listing__card-list').forEach((_sel) => {
				slider(_sel);
			});
		}
		if (document.querySelector('.sc__slider')) {
			document.querySelectorAll('.sc__list').forEach((_sel) => {
				slider(_sel);
			});
		}
	});

	window.addEventListener('load', () => {
		document.querySelectorAll('.modal-trigger').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				const modal = e.currentTarget.parentNode.parentNode.querySelector('.modal');
				modal.classList.add('modal--active');
				modal.querySelector('iframe').setAttribute('src', modal.querySelector('iframe').src);
			});
		});

		document.querySelectorAll('.modal__close').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();

				e.currentTarget.parentNode.parentNode.classList.remove('modal--active');
			});
		});

		if (document.querySelector('.site-page')) {
			lazyloadElements();
		}

		document.querySelectorAll('table').forEach((_sel) => {
			const tableParent = _sel.parentNode;
			const tableWrapper = document.createElement('div');
			tableWrapper.classList.add('site-table-container');
			tableWrapper.appendChild(_sel);
			tableParent.appendChild(tableWrapper);
		});
	});

	window.addEventListener('resize', () => {
	});
})(document, window, history);

((document, window) => {
	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth !== window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);
})(document, window);
